import React from 'react';
import { useInView } from '../hooks/useInView';

const stats = [
  { number: '4+', label: 'Years Experience' },
  { number: '3', label: 'Roles Held' },
  { number: '2+', label: 'Projects Shipped' },
  { number: '∞', label: 'Bugs Fixed' },
];

export default function About() {
  const [ref, inView] = useInView(0.15);

  return (
    <section id="about" ref={ref} style={{ padding: 'clamp(80px, 10vw, 140px) clamp(24px, 8vw, 120px)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'clamp(48px, 6vw, 100px)', alignItems: 'start' }}>

          {/* Left col */}
          <div style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}>
            <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--accent-warm)', marginBottom: 20 }}>
              01 — About
            </p>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 4vw, 52px)', lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: 28 }}>
              Engineering systems<br />
              <em style={{ color: 'var(--ink-3)' }}>that scale.</em>
            </h2>
            <div style={{ width: 48, height: 2, background: 'var(--accent-warm)', marginBottom: 32 }} />
            <p style={{ color: 'var(--ink-2)', lineHeight: 1.8, fontWeight: 300, fontSize: 16, marginBottom: 20 }}>
              I'm a Software Engineer based in Battaramulla, Sri Lanka, with a passion for building
              high-performance, event-driven backend systems. My work spans microservices architecture,
              ERP integrations, and real-time data pipelines.
            </p>
            <p style={{ color: 'var(--ink-2)', lineHeight: 1.8, fontWeight: 300, fontSize: 16, marginBottom: 20 }}>
              Currently at Fortude as a Software Engineer, I design and optimize distributed systems
              integrated with Infor M3 ERP — focusing on Kafka pipelines, Redis caching, and
              observability with New Relic.
            </p>
            <p style={{ color: 'var(--ink-2)', lineHeight: 1.8, fontWeight: 300, fontSize: 16 }}>
              Outside of production systems, I explore personal projects in real-time communication,
              encryption, and community-driven platforms — always with an eye on performance and clean architecture.
            </p>
          </div>

          {/* Right col */}
          <div style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease 0.2s' }}>
            {/* Stats */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, background: 'var(--border)', border: '1px solid var(--border)', marginBottom: 48 }}>
              {stats.map(({ number, label }) => (
                <div key={label} style={{ background: 'var(--cream)', padding: '32px 24px' }}>
                  <p style={{ fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1, color: 'var(--ink)', marginBottom: 8 }}>{number}</p>
                  <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-3)' }}>{label}</p>
                </div>
              ))}
            </div>

            {/* Education */}
            <div>
              <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: 20 }}>Education</p>
              {[
                { degree: 'B.Sc. (Hons) Management & IT', school: 'University of Kelaniya', year: '2018 – 2022' },
                { degree: 'G.C.E A/L — Physical Stream', school: 'D.S. Senanayake College', year: '2016' },
              ].map(e => (
                <div key={e.degree} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '16px 0', borderBottom: '1px solid var(--border)', gap: 16 }}>
                  <div>
                    <p style={{ fontWeight: 500, fontSize: 15, color: 'var(--ink)', marginBottom: 4 }}>{e.degree}</p>
                    <p style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--ink-3)' }}>{e.school}</p>
                  </div>
                  <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)', whiteSpace: 'nowrap' }}>{e.year}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
